var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-base-custom"},[_c('div',{staticClass:"customer-container"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"custom-item app-flex-mid-center"},[_c('img',{staticClass:"customer-icon",attrs:{"src":require('../../../assets/customer/' + item + '.png')}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }